import React from 'react';

import InvestmentCardCalloutsX3 from '../components/InvestmentCardCalloutsX3';
import InvestmentCardActuals from '../components/InvestmentCardActuals';
import InvestmentCardEmptyPlaceholder from '../components/InvestmentCardEmptyPlaceholder';

const section4FactoryFactory = (props) => {
  const {
    minimum,
    payoutLabel,
    targetHoldMin,
    targetHoldMax,
    reit,
    propertyType,
    status,
    actualIrr,
    actualHold,
    investmentTypeDisplay,
    gtkyApproved,
    id,
    payoutTooltip,
    distribution,
    distributionMoreInfo,
    distributionTooltip,
    eligible1031,
    irrObjective,
    returnObjective,
    blurContent,
  } = props;

  const section4Factory = () => {
    if (status === 'status-40-closed') {
      if (!gtkyApproved) {
        return (
          <InvestmentCardEmptyPlaceholder />
        );
      }

      return (
        <InvestmentCardActuals
          actualIrr={actualIrr}
          actualHold={actualHold}
          investmentTypeDisplay={investmentTypeDisplay}
        />
      );
    }

    return (
      <InvestmentCardCalloutsX3
        gtkyApproved={gtkyApproved}
        investmentTypeDisplay={investmentTypeDisplay}
        minimum={minimum}
        payoutLabel={payoutLabel}
        propertyType={propertyType}
        targetHoldMin={targetHoldMin}
        targetHoldMax={targetHoldMax}
        reit={reit}
        status={status}
        id={id}
        payoutTooltip={payoutTooltip}
        distribution={distribution}
        distributionMoreInfo={distributionMoreInfo}
        distributionTooltip={distributionTooltip}
        eligible1031={eligible1031}
        irrObjective={irrObjective}
        returnObjective={returnObjective}
        blurContent={blurContent}
      />
    );
  };

  return section4Factory;
};

export default section4FactoryFactory;
